import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class DashboardAPI {
  
  static list = (success, failure) => {
    fetch(Config.app.link + 'api/dashboard', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/dashboard/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (dashboard, success, failure) => {
    fetch(Config.app.link + 'api/dashboard', new Header('POST', dashboard))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/dashboard/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default DashboardAPI;